function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1.800781 25.648438 L 11.519531 19.710938 L 12.238281 8.371094 L 20.789062 15.839844 L 31.859375 12.960938 L 27.449219 23.398438 L 33.660156 33.03125 L 22.230469 32.039062 L 15.03125 40.949219 L 12.421875 29.789062 Z M 22.589844 62.460938 L 34.921875 54.988281 L 35.730469 40.679688 L 46.53125 50.039062 L 60.390625 46.441406 L 54.898438 59.671875 L 62.640625 71.730469 L 48.328125 70.558594 L 39.238281 81.628906 L 35.910156 67.679688 Z M 56.339844 31.320312 L 66.148438 25.378906 L 66.78125 13.949219 L 75.421875 21.421875 L 86.488281 18.539062 L 81.988281 29.070312 L 88.199219 38.699219 L 76.859375 37.710938 L 69.570312 46.53125 L 66.960938 35.460938 Z M 56.339844 31.320312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStars);
export default __webpack_public_path__ + "static/media/three-stars.acdce4456b9396343a970990edb1dd37.svg";
export { ForwardRef as ReactComponent };